import { telephone } from "@simplybusiness/icons";
import { Icon, LinkButton, useBreakpoint, Text } from "@simplybusiness/mobius";
import type { ReferredQuotesCallDisplayProps } from ".";
import classNames from "classnames";

export const ReferredQuotesCallDisplay = ({
  quote,
  displayVariant,
}: ReferredQuotesCallDisplayProps) => {
  const { down } = useBreakpoint();
  const isMobile = down("md");
  const selectActionClasses = classNames(
    "mobius-referred-quotes-call-display__button",
    "mobius-referred-quotes-call-displays__link-button",
  );
  const textClasses = classNames(
    "mobius-referred-quotes-call-display__button",
    "mobius-referred-quotes-call-display__bind-sub-text",
  );
  return isMobile ? (
    <LinkButton
      size="sm"
      href={`tel:${quote.offlinePurchaseOnlyNumber}`}
      className={selectActionClasses}
    >
      <Icon icon={telephone} size="xs" />
      &nbsp;Call to Buy
    </LinkButton>
  ) : displayVariant === "qcp" ? (
    <Text data-testid="qcp-desktop-call-sub-text" className={textClasses}>
      Call to Buy
      <Text className="mobius-referred-quotes-call-display__qcp-phone-number">
        {quote.offlinePurchaseOnlyNumber}
      </Text>
    </Text>
  ) : (
    <Text
      data-testid="qds-desktop-call-sub-text"
      className="mobius-quote-card__bind-sub-text"
    >
      {quote.offlinePurchaseOnlyText}
      <Text className="mobius-referred-quotes-call-display__qds-phone-number">
        {quote.offlinePurchaseOnlyNumber}
      </Text>
    </Text>
  );
};
